// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-section-1 {
  width: 75%;
}

.product-section-1 .product-box {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.product-box .product-image-container img {
  height: 350px;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.product-box .product-image-container img:hover {
  transform: scale(1.06);
  transition: 0.1s ease-in;
}

.product-section-2 {
  width: 75%;
}

.product-section-2 .card {
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  height: 400px;
  cursor: pointer;
}

.product-section-2 .card img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.product-section-2-content a:hover {
  filter: brightness(0.9);
  transition: 0.1s ease-in;
}

@media (min-width: 600px) and (max-width: 1080px) {
  .product-section-1 .product-box-content {
    flex-wrap: wrap;
    justify-content: center;
  }
  .product-section-2 .card {
    height: 300px;
  }
}

@media (max-width: 580px) {
  html {
    font-size: 85%;
  }
  .product-section-1 .product-box-content {
    flex-wrap: wrap;
    justify-content: center;
  }
  .product-box-content h3 {
    text-align: center;
  }
  .product-section-2-content {
    flex-wrap: wrap;
    text-align: center;
  }
  .product-text-description p {
    text-align: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/product.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".product-section-1 {\r\n  width: 75%;\r\n}\r\n\r\n.product-section-1 .product-box {\r\n  background-color: #fff;\r\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\r\n}\r\n\r\n.product-box .product-image-container img {\r\n  height: 350px;\r\n  width: 100%;\r\n  object-fit: cover;\r\n  border-radius: 10px;\r\n}\r\n\r\n.product-box .product-image-container img:hover {\r\n  transform: scale(1.06);\r\n  transition: 0.1s ease-in;\r\n}\r\n\r\n.product-section-2 {\r\n  width: 75%;\r\n}\r\n\r\n.product-section-2 .card {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: start;\r\n  width: 100%;\r\n  height: 400px;\r\n  cursor: pointer;\r\n}\r\n\r\n.product-section-2 .card img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.product-section-2-content a:hover {\r\n  filter: brightness(0.9);\r\n  transition: 0.1s ease-in;\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n  .product-section-1 .product-box-content {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  .product-section-2 .card {\r\n    height: 300px;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  html {\r\n    font-size: 85%;\r\n  }\r\n  .product-section-1 .product-box-content {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  .product-box-content h3 {\r\n    text-align: center;\r\n  }\r\n  .product-section-2-content {\r\n    flex-wrap: wrap;\r\n    text-align: center;\r\n  }\r\n  .product-text-description p {\r\n    text-align: start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
